import styled, { css } from 'styled-components';

import {
  TActiveStyleProps,
  TCheckboxStylesProps,
  TRowStyleProps,
} from '@/shared/components/ui/shared-styles/shared-styles.types';

export const rowStyle = css<TRowStyleProps>`
  position: relative;
  transition: background-color 0.3s;
  background-color: ${({ theme }) => theme.palette.background.paper};

  &:hover {
    background-color: ${({ theme, $disabled }) =>
      !$disabled && `${theme.palette.primary.light}80`};
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  }
`;

export const activeStyles = css<TActiveStyleProps>`
  cursor: ${({ $disabled }) => ($disabled ? 'initial' : 'pointer')};
  ${rowStyle};
  transition: all 0.2s ease-in-out;

  background-color: ${({ $active, theme }) =>
    $active ? theme.palette.primary.light : theme.palette.background.paper};

  &:after {
    left: ${({ $active }) => ($active ? '0' : '1.25rem')};
    right: ${({ $active }) => ($active ? '0' : '1.25rem')};
    border-bottom: ${({ $active, theme }) =>
      $active
        ? `3px solid ${theme.palette.background.paper}`
        : `1px solid ${theme.palette.divider}`};
  }

  &:last-of-type:after {
    border-bottom: none;
  }

  &:hover {
    .MuiCheckbox-root {
      svg {
        transition: color 0.2s ease-in-out;
      }

      &:not(.Mui-checked):not(.Mui-disabled) > svg {
        color: ${({ theme }) => theme.palette.stroke.secondary};
      }
    }
  }
`;

export const checkboxStyles = css<TCheckboxStylesProps>`
  background: transparent;
  padding: 0;
  height: ${({ $size }) => ($size === 'large' ? '2.5rem' : '2rem')};
  width: ${({ $size }) => ($size === 'large' ? '2.5rem' : '2rem')};

  svg {
    color: ${({ theme }) => theme.palette.stroke.primary};
    height: ${({ $size }) => ($size === 'large' ? '1.25rem' : '1rem')};
    width: ${({ $size }) => ($size === 'large' ? '1.25rem' : '1rem')};
  }

  &.Mui-checked,
  &.MuiCheckbox-indeterminate {
    svg {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  &:hover {
    background: transparent;

    svg {
      color: ${({ theme }) => theme.palette.stroke.secondary};
    }
  }

  &.Mui-checked:hover,
  &.MuiCheckbox-indeterminate:hover {
    svg {
      color: ${({ theme }) => theme.palette.primary.dark};
    }
  }

  &.Mui-disabled,
  &.Mui-checked.Mui-disabled {
    svg {
      color: ${({ theme }) => theme.palette.background.tooltip};
    }
  }
`;

export const VisuallyHidden = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
`;
